import { createFileRoute } from '@tanstack/react-router';

import { AdminSettingsSectionPage } from '@pages/admin';

export const Route = createFileRoute('/$locale/_authenticated/admin/settings/business/$sectionId')({
  component: AdminBusinessSettingsSection,
});

function AdminBusinessSettingsSection() {
  const { sectionId } = Route.useParams();
  return <AdminSettingsSectionPage category="business" sectionId={sectionId} />;
}
